import { Injectable } from '@angular/core';
import * as urlParse from 'url-parse';
import { ParsedUrl } from './url-parser.types';

export const SSO_TOKEN_PARAMETER = 'i3jwt-token';
export const SSO_EXIT_PARAMETER = 'i3jwt-exit';
export const SSO_REALM_PARAMETER = 'realm';
export const SSO_REDIRECTURL_PARAMETER = 'redirectUrl';

@Injectable({ providedIn: 'root' })
export class AuthSSOProvider {
  constructor() {}

  redirectoToSSO(ssoUrl: string, ssoRealm: string) {
    const urlParts: ParsedUrl = this.parse(ssoUrl);
    const currentLocation = window.location.href;
    Object.assign(urlParts.query, { [SSO_REALM_PARAMETER]: ssoRealm, [SSO_REDIRECTURL_PARAMETER]: currentLocation } );
    window.location.href = urlParts.toString();
  }

  checkSSOAuthenticationSuccess(): boolean {
    return this.getToken() ? true : false;
  }

  getToken(): string {
    const urlParts: ParsedUrl = this.parse(location.href);
    return urlParts.query[SSO_TOKEN_PARAMETER];
  }

  private parse(url: string): ParsedUrl {
    const baseUrl = {};                              // Ensures that the parsing is independent from the current location of the browser.
    const parseQueryString = true;
    return urlParse(url, baseUrl, parseQueryString);
  }
}
